import { Node, mergeAttributes, nodeInputRule } from '@tiptap/core';

const HorizontalRule = Node.create({
    name: 'horizontalRule',
    defaultOptions: {
        HTMLAttributes: {},
    },
    group: 'block',
    parseHTML() {
        return [
            { tag: 'hr' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['hr', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
    },
    addCommands() {
        return {
            /**
             * Add a horizontal rule
             */
            setHorizontalRule: () => ({ tr, dispatch }) => {
                if (dispatch) {
                    tr.replaceSelectionWith(this.type.create());
                }
                return true;
            },
        };
    },
    addInputRules() {
        return [
            nodeInputRule(/^(?:---|___\s|\*\*\*\s)$/, this.type),
        ];
    },
});

export default HorizontalRule;
export { HorizontalRule };
//# sourceMappingURL=tiptap-extension-horizontal-rule.esm.js.map
